<div>
  <dl class="dl-card">
    @for (entry of entries; track entry) {
      <dt class="eyebrow-s-bold text-navy-700 dl-card__dt">
        {{ entry.label }}
      </dt>
      <dd class="dl-card__dd be-body-s-bold text-navy-700">
        {{ entry.value || '-' }}
      </dd>
    }
  </dl>

  <div class="btn-container be-btn-group be-btn-group--left">
    <app-be-button
      size="small"
      type="button"
      (click)="looksGood()"
      id="looks-good"
      [eevTrackClick]="AuthLinkType.PROFILE_LOOKS_GOOD"
      >Looks good</app-be-button
      >
      <app-be-button
        id="update-info"
        size="small"
        class="w-full"
        type="button"
        variant="alt-borderless"
        (click)="onEdit.emit()"
        [eevTrackClick]="AuthLinkType.PROFILE_UPDATE_INFO"
        >Update my info</app-be-button
        >
      </div>
    </div>
